import { render, staticRenderFns } from "./form.vue?vue&type=template&id=2779a4a2&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=2779a4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779a4a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2779a4a2')) {
      api.createRecord('2779a4a2', component.options)
    } else {
      api.reload('2779a4a2', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=2779a4a2&scoped=true&", function () {
      api.rerender('2779a4a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared_store/form.vue"
export default component.exports